import { InvoiceDetailDoc, IssueTaskCategory, issueTaskCategoryMap } from '@gooduncles/gu-app-schema';
import { calcTaxForPrice } from 'src/utils/order-util';

export const mergeOrderProductWithStoreIssue = (invoiceDetail: InvoiceDetailDoc) => {
  const { orders = [], storeIssues = [], issueTasks = [] } = invoiceDetail;
  const orderProductInvoiceItems = orders.flatMap((order) =>
    order.products.map((p) => {
      const { supplyPrice, volume, tax, totalPrice } = calcTaxForPrice(p.snapshotPrice, p.volume, p.taxFree);
      return {
        date: order.date,
        name: p.fullName,
        price: p.snapshotPrice,
        supplyPrice,
        volume,
        tax,
        totalPrice,
        type: 'order',
      };
    })
  );
  const storeIssueItems = storeIssues.map((issue) => {
    return {
      date: issue.date,
      name: issue.message,
      price: issue.supplyPrice + issue.tax,
      supplyPrice: issue.supplyPrice,
      volume: issue.volume,
      tax: issue.tax,
      totalPrice: (issue.supplyPrice + issue.tax) * issue.volume,
      type: 'storeIssue',
    };
  });

  const issueTaskItems = issueTasks.flatMap((task) => {
    const shouldIncludeAmount = [IssueTaskCategory.REFUND, IssueTaskCategory.ADDITIONAL_CHARGE].includes(task.category);
    const taskProducts = task.products;
    if (taskProducts && taskProducts.length > 0) {
      const productList = taskProducts.map((product) => `• ${product.fullName} x ${product.volume}`);
      return {
        date: task.date,
        name: `${issueTaskCategoryMap[task.category]}\n${productList.join('\n')}`,
        price: shouldIncludeAmount ? task.amount?.totalAmount ?? 0 : 0,
        supplyPrice: shouldIncludeAmount ? task.amount?.supplyAmount ?? 0 : 0,
        volume: 1,
        tax: shouldIncludeAmount ? task.amount?.taxAmount ?? 0 : 0,
        totalPrice: shouldIncludeAmount ? task.amount?.totalAmount ?? 0 : 0,
        type: 'issueTask',
      };
    }
    return [
      {
        date: task.date,
        name: `${issueTaskCategoryMap[task.category]} ${task.memo}`,
        price: shouldIncludeAmount ? task.amount?.totalAmount ?? 0 : 0,
        supplyPrice: shouldIncludeAmount ? task.amount?.supplyAmount ?? 0 : 0,
        volume: 1,
        tax: shouldIncludeAmount ? task.amount?.taxAmount ?? 0 : 0,
        totalPrice: shouldIncludeAmount ? task.amount?.totalAmount ?? 0 : 0,
        type: 'issueTask',
      },
    ];
  });

  return [...orderProductInvoiceItems, ...storeIssueItems, ...issueTaskItems];
};
